module.exports = __webpack_public_path__ + "static/desktop/img/material-4.acfbaa57.jpg";